import { Component, Input, OnDestroy, ElementRef } from '@angular/core';
import { Product } from '../../models/product.model';
import { AppSettings } from '../../settings/app.settings';
import { Subscription, fromEvent } from 'rxjs';
import { auditTime } from 'rxjs/operators';

@Component({
    selector: 'main-stops',
    templateUrl: './main-stops.component.html',
    styleUrls: ['./main-stops.component.scss']
})
export class MainStopsComponent implements OnDestroy{
    @Input() product: Product
    public routes: any;
    public _mainStops: MainStopViewModel[];
    public startIndex: number;
    public endIndex: number;
    public screenWidth:number;
    public subscription:Subscription;
    private SWIPE_ACTION = { LEFT: 'swipeleft', RIGHT: 'swiperight' };

    constructor(){ }

    ngOnChanges(): void {
        this.screenWidth = 1270;
        this._mainStops = [];
        if (typeof window !== 'undefined') {
            this.screenWidth = window.innerWidth;
        }
        if (this.product) {            
            let cache = {};
            if (this.product.routes != null) {
                this.routes = this.product.routes;
                this.product.routes.map(route => {
                    route.stoppingPlaces.map(stop => {
                        if (stop.image && !cache[stop.id]) {
                            let _main = new MainStopViewModel();
                            _main.routeName = route.name;
                            _main.number = stop.number;
                            _main.name = stop.name;
                            _main.imageURL = stop.image;
                            _main.placeOrder = stop.placeOrder;
                            _main.color = route.color;
                            this._mainStops.push(_main);
                            cache[stop.id] = true;
                        }
                    })
                })
            }
            this.startIndex = -1;
            this.indexControl(this.screenWidth);
        }
        if (typeof window !== 'undefined') {
            this.subscription = fromEvent(window, 'resize').pipe(auditTime(500)).subscribe(ev => {
                if (this.product) {
                    this.startIndex = -1;
                    this.indexControl(ev.target['innerWidth']);
                }
            });
        }
    }

    /**
     * Control index of carousel depend of screen width
     * @param width screen width
     */
    private indexControl(width) {
        if (width <= 700)
            this._mainStops.length <= 1 ? this.endIndex = this._mainStops.length : this.endIndex = 1;
        else if (width > 700 && width < 1024)
            this._mainStops.length <= 2 ? this.endIndex = this._mainStops.length : this.endIndex = 2;
        else if (width >= 1024 && width < 1270)
            this._mainStops.length <= 3 ? this.endIndex = this._mainStops.length : this.endIndex = 3;
        else if (width >= 1270 && width < 1550)
            this._mainStops.length <= 4 ? this.endIndex = this._mainStops.length : this.endIndex = 4;
        else if (width >= 1550 && width < 1820)
            this._mainStops.length <= 5 ? this.endIndex = this._mainStops.length : this.endIndex = 5;
        else if (width > 1820)
            this._mainStops.length <= 6 ? this.endIndex = this._mainStops.length : this.endIndex = 6;
    }

    ngOnDestroy(): void {
        //Called once, before the instance is destroyed.
        //Add 'implements OnDestroy' to the class.
        if(this.subscription)
            this.subscription.unsubscribe();
    }

    getUrl(url: string) {
        return `${AppSettings.STOP_IMAGES}${url}`;
    }

    /**
    * Previous route icon
    */
    previousItem() {
        if (this.startIndex != -1) {
            this.startIndex--;
            this.endIndex--;
        }
    }

    /**
     * Next route icon
     */
    nextItem() {
        if (this.endIndex != this._mainStops.length) {
            this.startIndex++;
            this.endIndex++;
        }
    }

    /**
    * Gesture control for the side menu & add animations
    * @param action screen touch actions
    */
    swipe(action = this.SWIPE_ACTION.RIGHT) {
      if(action == this.SWIPE_ACTION.LEFT) 
        this.nextItem(); 
      if(action == this.SWIPE_ACTION.RIGHT)
        this.previousItem();
    }
}

/**
 * View model class for displaying main stops
 */
class MainStopViewModel {
    /** Name of the route where stop belongs */
    public routeName: string;
    /** Number of the stop in the route indicated by routeName */
    public number: string;
    /** Name of the stop. */
    public name: string;
    /** Url for the image associated to the stop. */
    public imageURL: string;
    /** Order */
    public placeOrder: number;
    /** Color */
    public color:string;
}